import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="rounded-2xl overflow-hidden relative h-[300px] md:h-[380px]">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20theater%20stage%20with%20red%20velvet%20curtains%20and%20spotlight%2C%20cinematic%20atmosphere%2C%20empty%20stage%20with%20mysterious%20glow%2C%20elegant%20dark%20aesthetic%2C%20theatrical%20moody%20lighting%2C%20deep%20crimson%20and%20black%20tones%2C%20dramatic%20shadows&width=1800&height=800&seq=cta-home-bg&orientation=landscape"
          alt="黑料视频 - 吃瓜社区"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white max-w-2xl">
            加入<em className="italic text-accent-400 not-italic font-normal">黑料视频</em>，一起吃瓜不迷路
          </h2>
          <p className="mt-4 text-white/70 text-sm md:text-base max-w-lg">
            每日更新最新爆料，明星黑料、网红爆料、社会热点一站式浏览
          </p>
          <Link
            to="/category/mingxing-heiliao"
            className="mt-8 px-8 py-3 bg-white hover:bg-white/90 text-foreground-950 rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
          >
            立即开始吃瓜
          </Link>
        </div>
      </div>
    </section>
  );
}